import api from "./api";

const qs = (p) =>
  new URLSearchParams(
    Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
  );

const checklistService = {
  meta: () => api("GET", "/checklists/meta"),
  dashboard: (p = {}) => api("GET", `/checklists/dashboard?${qs(p)}`),

  listarModelos: (p = {}) => api("GET", `/checklists/modelos?${qs(p)}`),
  buscarModelo: (id) => api("GET", `/checklists/modelos/${id}`),
  criarModelo: (data) => api("POST", "/checklists/modelos", data),
  atualizarModelo: (id, data) => api("PUT", `/checklists/modelos/${id}`, data),
  duplicarModelo: (id) => api("POST", `/checklists/modelos/${id}/duplicar`),

  listarAgendamentos: (p = {}) => api("GET", `/checklists/agendamentos?${qs(p)}`),
  criarAgendamento: (data) => api("POST", "/checklists/agendamentos", data),
  atualizarAgendamento: (id, data) => api("PUT", `/checklists/agendamentos/${id}`, data),

  listarTarefas: (p = {}) => api("GET", `/checklists/tarefas?${qs(p)}`),
  gerarTarefas: (data = {}) => api("POST", "/checklists/tarefas/gerar", data),
  cancelarTarefa: (id) => api("POST", `/checklists/tarefas/${id}/cancelar`),

  listarExecucoes: (p = {}) => api("GET", `/checklists/execucoes?${qs(p)}`),
  buscarExecucao: (id) => api("GET", `/checklists/execucoes/${id}`),
  imprimirExecucao: (id) => api("GET", `/checklists/execucoes/${id}/imprimir`),
  listarPlanosAcao: (idExecucao) => api("GET", `/checklists/execucoes/${idExecucao}/planos-acao`),
  criarPlanoAcao: (idExecucao, data) => api("POST", `/checklists/execucoes/${idExecucao}/planos-acao`, data),
  atualizarPlanoAcao: (idPlanoAcao, data) => api("PUT", `/checklists/planos-acao/${idPlanoAcao}`, data),
  criarOcorrenciaDaExecucao: (idExecucao, data) => api("POST", `/checklists/execucoes/${idExecucao}/ocorrencias`, data),

  portalMinhasTarefas: (p = {}) => api("GET", `/checklists/portal/tarefas/minhas?${qs(p)}`),
  portalIniciar: (data) => api("POST", "/checklists/portal/execucoes/iniciar", data),
  portalSalvarRespostas: (id, data) => api("PUT", `/checklists/portal/execucoes/${id}/respostas`, data),
  portalConcluir: (id, data = {}) => api("POST", `/checklists/portal/execucoes/${id}/concluir`, data),
  portalMinhasExecucoes: (p = {}) => api("GET", `/checklists/portal/execucoes/minhas?${qs(p)}`),
  portalBuscarExecucao: (id) => api("GET", `/checklists/portal/execucoes/${id}`),
  portalUploadFoto: (data) => api("POST", "/checklists/portal/upload-foto", data),
  portalSync: (acoes) => api("POST", "/checklists/portal/sync", { acoes }),
};

export default checklistService;
